export default "__VITE_ASSET__72283f27__"